import React from 'react';
import withRouting from './withRouting';

// Note: Redux store provider removed - no longer needed
// This HOC now only provides routing (BrowserRouter)
function withStoreAndRouter<P extends object>(WrappedComponent: React.ComponentType<P>): React.FC<P> {
  const Enhanced = withRouting(WrappedComponent);
  const WithStoreAndRouter: React.FC<P> = (props) => <Enhanced {...props} />;
  WithStoreAndRouter.displayName = `withStoreAndRouter(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithStoreAndRouter;
}

export default withStoreAndRouter;
